export default "__VITE_PUBLIC_ASSET__d9704ff8__"